// 3. 신청 정보 입력

document.addEventListener('DOMContentLoaded', () => {
  // 고객 정보 초기값 세팅
  initCustomerDefaults();

  // 휴대폰 번호 자동 하이픈
  initPhoneNumberFormatting();

  // 구매일 Flatpickr 초기화 (오늘 포함 과거만 선택)
  initPurchaseDatePicker();

  // 구매 정보 관련 초기화 - 조건부 실행
  if (SHOW_PURCHASE_INFO) {
    // 구매자와의 관계 선택에 따른 이름 필드 활성화
    initRelationshipBasedBuyerName();

    // 모름 체크박스 이벤트
    initUnknownCheckboxes();
  }

  // 필수 확인 체크박스 이벤트
  initConfirmCheckbox();

  // 상세 주소 없음 체크박스 이벤트
  initAddressDetailUnknownCheckbox();

  // 실시간 입력값 검증
  initStep3InputValidation();

  // Daum 배송지 검색 이벤트
  const addressBtn = document.querySelector('#as-form-3 .address-btn');
  if (addressBtn) {
    addressBtn.addEventListener('click', clickFindAddr);
  }

  // 방문 희망일 Flatpickr 초기화
  initVisitDatePicker();

  // 주소 입력 여부에 따라 방문 희망일 노출
  syncVisitDateVisibility();
});

const AS_STEP3_PROXY_BASE_URL = 'https://sidiz-shopify.sidiz.com';
const DELIVERY_AVAILABLE_DATE_ENDPOINT = `${AS_STEP3_PROXY_BASE_URL}/v2/as/delivery/available-date`;
const HOLIDAY_ENDPOINT = `${AS_STEP3_PROXY_BASE_URL}/api/v1/holidays`;
const KST_TIMEZONE = 'Asia/Seoul';
const VISIT_DATE_MAX_OFFSET_DAYS = 17;
const VISIT_DATE_FALLBACK_MIN_OFFSET_DAYS = 6;

let purchaseDatePickerInstance = null;
let visitDatePickerInstance = null;

function syncStep3Field(field, value) {
  if (typeof updateFormData === 'function') {
    updateFormData(field, value);
  }
}

// 휴대폰 번호 자동 하이픈 기능 초기화
function initPhoneNumberFormatting() {
  const applicantPhone1 = document.querySelector('#as-form-3 #applicant_phone_1');
  const applicantPhone2 = document.querySelector('#as-form-3 #applicant_phone_2');

  if (applicantPhone1) {
    applicantPhone1.addEventListener('input', () => {
      formatPhoneNumber(applicantPhone1);
      syncStep3Field('applicant_phone_1', applicantPhone1.value || '');
      if (typeof checkNextButtonState === 'function') {
        checkNextButtonState(3);
      }
    });
  }

  if (applicantPhone2) {
    applicantPhone2.addEventListener('input', () => {
      formatPhoneNumber(applicantPhone2);
      syncStep3Field('applicant_phone_2', applicantPhone2.value || '');
      if (typeof checkNextButtonState === 'function') {
        checkNextButtonState(3);
      }
    });
  }
}

function formatPhoneNumber(input) {
  // 현재 입력 값에서 숫자만 추출
  const onlyNumbers = input.value.replace(/\D/g, '');

  let formattedNumber = onlyNumbers;
  if (onlyNumbers.length > 3 && onlyNumbers.length <= 7) {
    formattedNumber = `${onlyNumbers.slice(0, 3)}-${onlyNumbers.slice(3)}`;
  } else if (onlyNumbers.length > 7) {
    formattedNumber = `${onlyNumbers.slice(0, 3)}-${onlyNumbers.slice(3, 7)}-${onlyNumbers.slice(7, 11)}`;
  }

  // 최대 11자리까지만 표시
  input.value = formattedNumber;
}

// 고객 정보 초기값 세팅
function initCustomerDefaults() {
  const nameInput = document.querySelector('#as-form-3 #applicant_name');
  const phoneInput = document.querySelector('#as-form-3 #applicant_phone_1');

  if (nameInput && typeof customer_name !== 'undefined' && customer_name) {
    nameInput.value = customer_name;
  }

  if (phoneInput && typeof customer_phone !== 'undefined' && customer_phone) {
    // +82 국가코드 제거 후 0 붙이기
    let phone = customer_phone.replace(/\D/g, '');
    if (phone.startsWith('82')) {
      phone = '0' + phone.slice(2);
    }
    phoneInput.value = phone;
    formatPhoneNumber(phoneInput);
  }

  if (typeof updateFormData === 'function') {
    updateFormData('applicant_name', nameInput?.value || '');
    updateFormData('applicant_phone_1', phoneInput?.value || '');
  }
}

// 모름 체크박스 초기화
function initUnknownCheckboxes() {
  const unknownCheckboxes = [
    {
      checkbox: '#buyer_name_unknown',
      checkboxField: 'buyer_name_unknown',
      inputs: [{ selector: '#buyer_name', field: 'buyer_name' }]
    },
    {
      checkbox: '#purchase_date_unknown',
      checkboxField: 'purchase_date_unknown',
      inputs: [{ selector: '#purchase_date', field: 'purchase_date' }]
    },
    {
      checkbox: '#purchase_channel_unknown',
      checkboxField: 'purchase_channel_unknown',
      inputs: [
        { selector: '#purchase_channel', field: 'purchase_channel' },
        { selector: '#purchase_channel_detail', field: 'purchase_channel_detail' }
      ]
    }
  ];

  unknownCheckboxes.forEach(({ checkbox, checkboxField, inputs }) => {
    const checkboxEl = document.querySelector(checkbox);
    const mappedInputs = inputs
      .map(({ selector, field }) => ({ field, el: document.querySelector(selector) }))
      .filter(({ el }) => Boolean(el));

    if (checkboxEl && mappedInputs.length > 0) {
      checkboxEl.addEventListener('change', () => {
        syncStep3Field(checkboxField, checkboxEl.checked);

        mappedInputs.forEach(({ field, el }) => {
          if (checkboxEl.checked) {
            el.value = '';
            el.disabled = true;
            syncStep3Field(field, '');
          } else {
            el.disabled = false;
            syncStep3Field(field, el.value || '');
          }
        });

        // 버튼 상태 체크 추가
        if (typeof checkNextButtonState === 'function') {
          checkNextButtonState(3);
        }
      });
    }
  });
}

// 구매자와의 관계 선택에 따른 구매자 이름 필드 활성화/비활성화
function initRelationshipBasedBuyerName() {
  const relationshipSelect = document.querySelector('#as-form-3 #applicant_relationship');
  const buyerNameInput = document.querySelector('#as-form-3 #buyer_name');
  const buyerNameUnknownCheckbox = document.querySelector('#as-form-3 #buyer_name_unknown');
  const applicantNameInput = document.querySelector('#as-form-3 #applicant_name');

  if (!relationshipSelect) return;

  const isSelfSelected = () => relationshipSelect.value === '본인' || relationshipSelect.value === '';

  const applyBuyerNameState = () => {
    const isSelf = isSelfSelected();

    if (isSelf) {
      // 본인: buyer_name은 readonly + applicant_name 값으로 채움
      if (buyerNameInput) {
        buyerNameInput.value = applicantNameInput?.value || '';
        buyerNameInput.readOnly = true;
        buyerNameInput.disabled = false;
      }
      if (buyerNameUnknownCheckbox) {
        buyerNameUnknownCheckbox.checked = false;
        buyerNameUnknownCheckbox.disabled = true;
      }
    } else {
      // 본인 이외: buyer_name 입력 가능, 값 초기화
      if (buyerNameInput) {
        buyerNameInput.value = '';
        buyerNameInput.readOnly = false;
        buyerNameInput.disabled = buyerNameUnknownCheckbox?.checked || false;
      }
      if (buyerNameUnknownCheckbox) {
        buyerNameUnknownCheckbox.disabled = false;
      }
    }

    if (typeof updateFormData === 'function') {
      updateFormData('is_different', !isSelf);
      updateFormData('buyer_name', buyerNameInput?.value || '');
      updateFormData('applicant_relationship', relationshipSelect.value || '');
    }

    if (typeof checkNextButtonState === 'function') {
      checkNextButtonState(3);
    }
  };

  // 관계 변경 시
  relationshipSelect.addEventListener('change', applyBuyerNameState);

  // 신청자 이름 변경 시 본인인 경우 buyer_name 동기화
  if (applicantNameInput) {
    applicantNameInput.addEventListener('input', () => {
      if (typeof updateFormData === 'function') {
        updateFormData('applicant_name', applicantNameInput.value);
      }
      if (isSelfSelected() && buyerNameInput) {
        buyerNameInput.value = applicantNameInput.value;
        if (typeof updateFormData === 'function') {
          updateFormData('buyer_name', buyerNameInput.value);
        }
      }
    });
  }

  // 초기 상태 적용
  applyBuyerNameState();
}

// 필수 확인 체크박스 초기화
function initConfirmCheckbox() {
  const confirmCheckbox = document.querySelector('#as-form-3 #confirm_checkbox');

  if (confirmCheckbox) {
    confirmCheckbox.addEventListener('change', () => {
      syncStep3Field('confirm_checkbox', confirmCheckbox.checked);

      // 버튼 상태 체크
      if (typeof checkNextButtonState === 'function') {
        checkNextButtonState(3);
      }
    });
  }
}

function initAddressDetailUnknownCheckbox() {
  const checkbox = document.querySelector('#as-form-3 #address_detail_unknown');
  const detailInput = document.querySelector('#as-form-3 #address_detail');
  if (!checkbox || !detailInput) return;

  const applyState = (checked) => {
    if (checked) {
      detailInput.dataset.previousValue = detailInput.value || '';
      detailInput.value = '';
      detailInput.disabled = true;
      syncStep3Field('address_detail', '');
      syncStep3Field('address_detail_unknown', true);
      return;
    }

    detailInput.disabled = false;
    if (!detailInput.value && detailInput.dataset.previousValue) {
      detailInput.value = detailInput.dataset.previousValue;
      syncStep3Field('address_detail', detailInput.value || '');
    } else {
      syncStep3Field('address_detail', detailInput.value || '');
    }
    syncStep3Field('address_detail_unknown', false);
  };

  checkbox.addEventListener('change', () => {
    applyState(checkbox.checked);

    if (typeof checkNextButtonState === 'function') {
      checkNextButtonState(3);
    }
  });

  // 초기 상태 반영 (복원/초기 렌더 대응)
  applyState(checkbox.checked);
}

// 주소 찾기 버튼 클릭 시 실행되는 함수 (embed 모달 방식)
function clickFindAddr() {
  const overlay = document.getElementById('addr-modal-overlay');
  const modal = document.getElementById('addr-modal');
  const body = document.getElementById('addr-modal__body');
  const closeBtn = modal?.querySelector('.addr-modal__close');

  if (!overlay || !modal || !body) return;

  // 기존 embed 내용 초기화
  body.innerHTML = '';

  // 모달 열기
  overlay.classList.add('active');
  modal.classList.add('active');
  document.body.style.overflow = 'hidden';

  new daum.Postcode({
    oncomplete: function(data) {
      let addr = '';

      // 사용자가 선택한 주소 타입에 따라 도로명 또는 지번 출력
      if (data.userSelectedType === 'R') {
        addr = data.roadAddress;  // 도로명 주소
      } else if (data.userSelectedType === 'J') {
        addr = data.jibunAddress;  // 지번 주소
      }

      // 우편번호와 주소 정보를 input에 채우기
      const zonecodeInput = document.querySelector('#as-form-3 #address_zonecode');
      const mainAddrInput = document.querySelector('#as-form-3 #address_main');

      if (zonecodeInput) {
        zonecodeInput.value = data.zonecode;
      }

      if (mainAddrInput) {
        mainAddrInput.value = addr;
      }

      // 상세 주소 입력란에 포커스
      const detailAddrInput = document.querySelector('#as-form-3 #address_detail');
      if (detailAddrInput && !detailAddrInput.disabled) {
        detailAddrInput.focus();
      }

      // formData에 저장
      if (typeof updateFormData === 'function') {
        updateFormData('address_zonecode', data.zonecode);
        updateFormData('address_main', addr);
      }

      // 주소 입력 완료 시 방문 희망일 노출
      syncVisitDateVisibility();
      refreshAvailableVisitDates();

      // 버튼 상태 체크
      if (typeof checkNextButtonState === 'function') {
        checkNextButtonState(3);
      }

      closeAddrModal();
    }
  }).embed(body);

  function onClose() {
    closeAddrModal();
    closeBtn?.removeEventListener('click', onClose);
  }
  closeBtn?.addEventListener('click', onClose);

  function onOverlayClick() {
    closeAddrModal();
    overlay.removeEventListener('click', onOverlayClick);
  }
  overlay.addEventListener('click', onOverlayClick);
}

function closeAddrModal() {
  const overlay = document.getElementById('addr-modal-overlay');
  const modal = document.getElementById('addr-modal');
  const body = document.getElementById('addr-modal__body');

  overlay?.classList.remove('active');
  modal?.classList.remove('active');
  document.body.style.overflow = '';
  if (body) {
    // Daum Postcode 내부 cleanup이 먼저 끝난 뒤 DOM 초기화
    setTimeout(() => {
      body.innerHTML = '';
    }, 0);
  }
}

function syncVisitDateVisibility() {
  const wrapper = document.querySelector('#as-form-3 [data-visit-date-section]');
  if (!wrapper) return;

  const zonecodeInput = document.querySelector('#as-form-3 #address_zonecode');
  const mainAddrInput = document.querySelector('#as-form-3 #address_main');
  const visitDateInput = document.querySelector('#as-form-3 #visit_date');

  const hasAddress =
    !!(zonecodeInput && zonecodeInput.value.trim()) &&
    !!(mainAddrInput && mainAddrInput.value.trim());

  wrapper.classList.toggle('hidden', !hasAddress);

  if (!hasAddress && visitDateInput) {
    visitDateInput.value = '';
    if (visitDatePickerInstance) {
      visitDatePickerInstance.clear();
      visitDatePickerInstance.set('minDate', null);
      visitDatePickerInstance.set('maxDate', null);
      visitDatePickerInstance.set('enable', []);
    }
    if (typeof updateFormData === 'function') {
      updateFormData('visit_date', '');
    }
  }
}

function initPurchaseDatePicker() {
  const purchaseDateInput = document.querySelector('#as-form-3 #purchase_date');
  const purchaseDateIcon = document.querySelector('#as-form-3 .purchase-date-wrapper .purchase-date-icon');
  if (!purchaseDateInput || typeof flatpickr === 'undefined') return;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  purchaseDatePickerInstance = flatpickr(purchaseDateInput, {
    locale: 'ko',
    dateFormat: 'Y-m-d',
    maxDate: today,
    disableMobile: true,
    onReady: function(selectedDates, dateStr, instance) {
      instance.calendarContainer.classList.add('as-custom-calendar');
    },
    onChange: function () {
      syncStep3Field('purchase_date', purchaseDateInput.value || '');
      if (typeof checkNextButtonState === 'function') {
        checkNextButtonState(3);
      }
    },
  });

  if (purchaseDateIcon) {
    purchaseDateIcon.addEventListener('click', () => {
      if (!purchaseDatePickerInstance || purchaseDateInput.disabled) return;
      purchaseDatePickerInstance.open();
    });
  }
}

// ========================================
// 방문 희망일 Flatpickr
// ========================================
async function initVisitDatePicker() {
  const visitDateInput = document.querySelector('#as-form-3 #visit_date');
  const visitDateIcon = document.querySelector('#as-form-3 .visit-date-wrapper .visit-date-icon');
  if (!visitDateInput || typeof flatpickr === 'undefined') return;

  visitDatePickerInstance = flatpickr(visitDateInput, {
    locale: 'ko',
    dateFormat: 'Y-m-d',
    enable: [],
    disableMobile: true,
    onReady: function(selectedDates, dateStr, instance) {
      instance.calendarContainer.classList.add('as-custom-calendar');
    },
    onChange: function () {
      syncStep3Field('visit_date', visitDateInput.value || '');
      if (typeof checkNextButtonState === 'function') {
        checkNextButtonState(3);
      }
    },
  });

  if (visitDateIcon) {
    visitDateIcon.addEventListener('click', () => {
      if (!visitDatePickerInstance || visitDateInput.disabled) return;
      visitDatePickerInstance.open();
    });
  }

  await refreshAvailableVisitDates();
}

async function refreshAvailableVisitDates() {
  const zonecodeInput = document.querySelector('#as-form-3 #address_zonecode');
  if (!zonecodeInput || !visitDatePickerInstance) return;

  const zip = (zonecodeInput.value || '').trim();

  if (!zip) {
    visitDatePickerInstance.clear();
    visitDatePickerInstance.set('minDate', null);
    visitDatePickerInstance.set('maxDate', null);
    visitDatePickerInstance.set('enable', []);
    if (typeof updateFormData === 'function') {
      updateFormData('visit_date', '');
    }
    return;
  }

  try {
    const visitDatePolicy = await fetchAvailableVisitDatePolicy(zip);
    visitDatePickerInstance.clear();
    visitDatePickerInstance.set('minDate', visitDatePolicy.minDate || null);
    visitDatePickerInstance.set('maxDate', visitDatePolicy.maxDate || null);
    visitDatePickerInstance.set('enable', visitDatePolicy.enableRules);

    // 기존 선택일이 허용 조건에 없으면 초기화
    const currentValue = (visitDatePickerInstance.input?.value || '').trim();
    if (currentValue && !isVisitDateSelectable(currentValue, visitDatePolicy)) {
      visitDatePickerInstance.clear();
      if (typeof updateFormData === 'function') {
        updateFormData('visit_date', '');
      }
    }
  } catch (error) {
    console.error('희망 방문일 조회 실패:', error);
    visitDatePickerInstance.clear();
    visitDatePickerInstance.set('minDate', null);
    visitDatePickerInstance.set('maxDate', null);
    visitDatePickerInstance.set('enable', []);
    if (typeof updateFormData === 'function') {
      updateFormData('visit_date', '');
    }
  }
}

async function fetchAvailableVisitDatePolicy(zip) {
  const [response, fallbackRange] = await Promise.all([
    fetch(DELIVERY_AVAILABLE_DATE_ENDPOINT, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ zip }),
    }),
    getFallbackVisitDateRange(),
  ]);

  if (!response.ok) {
    throw new Error(`available-date HTTP ${response.status}`);
  }

  const json = await response.json();
  const rows = Array.isArray(json?.list) ? json.list : [];

  // API 값이 있으면: 리스트에 포함된 날짜만 선택 가능하되,
  // 기존 시작일과 공통 D+17 최대일 범위를 적용하고,
  // 실제 선택 제한은 캘린더 정책(일요일 제외) 기준으로 한 번 더 적용한다.
  if (rows.length > 0) {
    const availableDates = Array.from(
      new Set(
        rows
          .map((row) => normalizeApiDateToYmd(row?.calYmd))
          .filter(Boolean)
          .filter((dateStr) => isVisitDateSelectable(dateStr, fallbackRange))
      )
    );

    return createVisitDatePolicy({
      minDate: fallbackRange.minDate,
      maxDate: fallbackRange.maxDate,
      allowedDates: availableDates,
    });
  }

  // API 값이 없으면: 기존 시작일과 선택 요일 정책을 유지하고 D+17까지만 노출
  return createVisitDatePolicy({
    minDate: fallbackRange.minDate,
    maxDate: fallbackRange.maxDate,
    allowedDates: null,
  });
}

function createVisitDatePolicy({ minDate, maxDate, allowedDates }) {
  const usesAllowedDates = Array.isArray(allowedDates);
  const normalizedAllowedDates = usesAllowedDates
    ? allowedDates.filter((dateStr) => /^\d{4}-\d{2}-\d{2}$/.test(String(dateStr || '').trim()))
    : [];
  const allowedDateSet = usesAllowedDates ? new Set(normalizedAllowedDates) : null;
  const enableRules = usesAllowedDates
    ? normalizedAllowedDates
    : [
      (date) => {
        const dateStr = formatDateToYmd(date);
        return isVisitDateSelectable(dateStr, { minDate, maxDate, allowedDateSet });
      }
    ];

  return { minDate, maxDate, enableRules, allowedDateSet, usesAllowedDates };
}

function isVisitDateSelectable(dateStr, policy) {
  const parsedDate = parseYmdToUtcDate(dateStr);
  if (!parsedDate) return false;

  if (parsedDate.getUTCDay() === 0) return false;

  const allowedDateSet = policy?.allowedDateSet instanceof Set ? policy.allowedDateSet : null;
  if (policy?.usesAllowedDates) {
    return Boolean(allowedDateSet && allowedDateSet.has(dateStr));
  }

  const minDate = String(policy?.minDate || '').trim();
  const maxDate = String(policy?.maxDate || '').trim();

  if (minDate && dateStr < minDate) return false;
  if (maxDate && dateStr > maxDate) return false;

  return true;
}

async function getFallbackVisitDateRange() {
  const todayKst = getKstTodayUtcDate();
  const maxDate = addUtcDays(todayKst, VISIT_DATE_MAX_OFFSET_DAYS);
  let holidayDateSet = new Set();

  try {
    holidayDateSet = await fetchHolidayDateSet(todayKst, maxDate);
  } catch (error) {
    console.warn('공휴일 조회 실패, 주말 기준으로 시작일 계산:', error);
  }

  const minDate = addUtcBusinessDays(
    todayKst,
    VISIT_DATE_FALLBACK_MIN_OFFSET_DAYS,
    holidayDateSet
  );

  return {
    minDate: formatUtcDateToYmd(minDate),
    maxDate: formatUtcDateToYmd(maxDate),
  };
}

async function fetchHolidayDateSet(startDate, endDate) {
  const params = new URLSearchParams({
    startDate: formatUtcDateToYmd(startDate),
    endDate: formatUtcDateToYmd(endDate),
  });
  const response = await fetch(`${HOLIDAY_ENDPOINT}?${params.toString()}`, {
    headers: { 'Accept': 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`holidays HTTP ${response.status}`);
  }

  const json = await response.json();
  const holidays = Array.isArray(json?.data?.holidays) ? json.data.holidays : [];

  return new Set(
    holidays
      .map((date) => normalizeApiDateToYmd(date))
      .filter(Boolean)
  );
}

function formatDateToYmd(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const y = String(date.getFullYear());
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function parseYmdToUtcDate(ymd) {
  const raw = String(ymd || '').trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) return null;

  const [year, month, day] = raw.split('-').map(Number);
  if (!year || !month || !day) return null;

  return new Date(Date.UTC(year, month - 1, day));
}

function normalizeApiDateToYmd(rawDate) {
  const raw = String(rawDate || '').trim();
  if (/^\d{8}$/.test(raw)) {
    return `${raw.slice(0, 4)}-${raw.slice(4, 6)}-${raw.slice(6, 8)}`;
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    return raw;
  }
  return '';
}

function isWeekendUtcDate(date) {
  const day = date.getUTCDay();
  return day === 0 || day === 6;
}

function addUtcDays(baseDate, days) {
  const nextDate = new Date(baseDate.getTime());
  nextDate.setUTCDate(nextDate.getUTCDate() + Number(days || 0));
  return nextDate;
}

function addUtcBusinessDays(baseDate, days, holidayDateSet = new Set()) {
  const targetDays = Number(days || 0);
  if (targetDays <= 0) {
    return new Date(baseDate.getTime());
  }

  const nextDate = new Date(baseDate.getTime());
  let countedDays = 0;

  while (countedDays < targetDays) {
    nextDate.setUTCDate(nextDate.getUTCDate() + 1);
    if (isWeekendUtcDate(nextDate)) continue;
    if (holidayDateSet.has(formatUtcDateToYmd(nextDate))) continue;
    countedDays += 1;
  }

  return nextDate;
}

function formatUtcDateToYmd(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const y = String(date.getUTCFullYear());
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  const d = String(date.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function getKstTodayUtcDate() {
  const now = new Date();
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: KST_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(now);

  const year = Number(parts.find((part) => part.type === 'year')?.value || 0);
  const month = Number(parts.find((part) => part.type === 'month')?.value || 0);
  const day = Number(parts.find((part) => part.type === 'day')?.value || 0);

  return new Date(Date.UTC(year, month - 1, day));
}

// ========================================
// 실시간 입력값 검증
// ========================================
function initStep3InputValidation() {
  const form3 = document.querySelector('#as-form-3');
  if (!form3) return;

  const syncTargets = [
    ['#buyer_name', 'buyer_name'],
    ['#purchase_date', 'purchase_date'],
    ['#purchase_channel', 'purchase_channel'],
    ['#purchase_channel_detail', 'purchase_channel_detail'],
    ['#applicant_name', 'applicant_name'],
    ['#applicant_relationship', 'applicant_relationship'],
    ['#applicant_phone_1', 'applicant_phone_1'],
    ['#applicant_phone_2', 'applicant_phone_2'],
    ['#address_detail', 'address_detail'],
    ['#visit_date', 'visit_date']
  ];

  syncTargets.forEach(([selector, field]) => {
    const input = form3.querySelector(selector);
    if (!input) return;

    const sync = () => {
      syncStep3Field(field, input.value || '');
      if (typeof checkNextButtonState === 'function') {
        checkNextButtonState(3);
      }
    };

    input.addEventListener('input', sync);
    input.addEventListener('change', sync);
  });
}
